import React, { Component } from 'react';
import PropTypes from 'prop-types';

function processPagination(pagination) {
  return {
    startPage: parseInt(pagination?.startPage ?? 1, 10),
    endPage: parseInt(pagination?.endPage ?? 1, 10),
    currentPage: parseInt(pagination?.current ?? 1, 10),
    itemsPerPage: parseInt(pagination?.numItemsPerPage ?? 1, 10),
    total: parseInt(pagination?.totalCount ?? 1, 10),
    pageCount: parseInt(pagination?.pageCount ?? 1, 10),
    currentItemCount: parseInt(pagination?.currentItemCount ?? 1, 10),
    lastItemNumber: parseInt(pagination?.lastItemNumber ?? 1, 10),
    pagesInRange: (pagination?.pagesInRange ?? [ 1 ]),
  };
}

export default function() {
  return (OriginalComponent) => {
    return class Pagination extends Component {
      static propTypes = {
        pagination: PropTypes.object.isRequired
      };

      constructor(props) {
        super(props);
        this.state = {
          pagination: processPagination(props.pagination)
        };
      }

      componentDidUpdate(prevProps, prevState, prevContext) {
        if (JSON.stringify(this.props.pagination) !== JSON.stringify(prevProps.pagination)) {
          this.setState({
            pagination: processPagination(this.props.pagination)
          });
        }
      }

      render() {
        const { pagination, ...props } = this.props;

        return (
          <OriginalComponent 
            originalPagination={pagination} 
            pagination={this.state.pagination} 
            {...props}
          >
            {this.props.children}
          </OriginalComponent>
        )
      }
    }
  };
}